
import React, { useState } from 'react';

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
  loading?: "eager" | "lazy";
  priority?: boolean;
  blurDataURL?: string;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  className,
  style,
  loading = "lazy",
  priority = false,
  blurDataURL
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  // Conversão para WebP se a URL for local
  const getWebpUrl = (url: string) => {
    if (url.startsWith('/lovable-uploads/')) {
      // Como não podemos converter diretamente, manteremos a URL original
      // Em um ambiente de produção, você teria versões WebP disponíveis
      return url;
    }
    return url;
  };

  // Determinar um tamanho adequado para a imagem
  const getSizedImage = (url: string) => {
    // Em produção, você poderia implementar um serviço de redimensionamento de imagem aqui
    return getWebpUrl(url);
  };

  return (
    <div className={`relative ${className || ''}`} style={style}>
      {blurDataURL && !isLoaded && (
        <div 
          className="absolute inset-0 blur-md bg-cover bg-center"
          style={{ 
            backgroundImage: `url(${blurDataURL})`,
            opacity: 0.7,
          }}
        />
      )}
      <img 
        src={getSizedImage(src)}
        alt={alt}
        width={width}
        height={height}
        className={`${className || ''} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        style={{
          ...style,
          objectFit: className?.includes('object-cover') ? 'cover' : undefined,
          objectPosition: className?.includes('object-center') ? 'center' : undefined,
        }}
        loading={priority ? 'eager' : loading}
        onLoad={() => setIsLoaded(true)}
        decoding="async"
        fetchPriority={priority ? 'high' : 'auto'}
      />
    </div>
  );
};

export default OptimizedImage;
